import { esc } from '../escape.js';

// Floating "who's on shift" indicator - a small circle pinned to the lower-right
// corner of the home page. Hover (or tap) reveals the list of staff currently
// clocked in, with an amber dot for anyone on break. Hidden when nobody is in.
class OnShiftView {
  _el = document.getElementById('onShiftBubble');

  constructor() {
    // Tap-to-toggle for touch devices (hover handles desktop via CSS).
    this._el?.addEventListener('click', e => {
      if (e.target.closest('.onshift-circle')) this._el.classList.toggle('onshift--open');
    });
    document.addEventListener('click', e => {
      if (!e.target.closest('#onShiftBubble')) this._el?.classList.remove('onshift--open');
    });
  }

  render(list) {
    if (!this._el) return;
    if (!list.length) {
      this._el.classList.add('hidden');
      this._el.innerHTML = '';
      return;
    }
    const fmtSince = iso => new Date(iso).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
    this._el.innerHTML = `
      <div class="onshift-pop">
        <p class="onshift-pop-title">On shift now</p>
        ${list.map(s => `
          <div class="onshift-row">
            <span class="onshift-dot${s.onBreak ? ' onshift-dot--break' : ''}"></span>
            <span class="onshift-name">${esc(s.name || 'Staff')}</span>
            <span class="onshift-meta">${s.onBreak ? 'On break' : `since ${fmtSince(s.clockedInAt)}`}</span>
          </div>`).join('')}
      </div>
      <button class="onshift-circle" type="button" aria-label="${list.length} staff on shift">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
        <span class="onshift-count">${list.length}</span>
      </button>`;
    this._el.classList.remove('hidden');
  }
}

export default new OnShiftView();
